module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 pb-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.name),
      expression: "reservation.customer.name"
    }],
    staticClass: "full",
    class: {
      'border-color-6': _vm.$v.reservation.customer.name.$invalid && !_vm.$v.reservation.customer.name.required
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(1), _vm._v(" "), _c('country-picker', {
    attrs: {
      "topCodes": _vm.topCountries,
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false,
      "customClass": 'mb-2',
      "error": !_vm.selectedCountry
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event, 'country')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('PhoneInput', {
    ref: "phoneInput",
    staticClass: "w-100",
    attrs: {
      "country": _vm.phoneCountry
    },
    on: {
      "validate": _vm.isPhoneValid,
      "country-changed": _vm.onFlagChanged,
      "input": _vm.onPhoneInput
    },
    model: {
      value: (_vm.reservation.customer.phone),
      callback: function($$v) {
        _vm.$set(_vm.reservation.customer, "phone", $$v)
      },
      expression: "reservation.customer.phone"
    }
  }), _vm._v(" "), (_vm.reservation.customer.phone && !_vm.customerPhoneValid) ? _c('div', {
    staticClass: "error"
  }, [_c('span', [_vm._v("Phone Number Invalid.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("\n                    Email\n                    "), (_vm.$v.reservation.customer.email.$invalid) ? _c('span', {
    staticClass: "color-6"
  }, [(!_vm.$v.reservation.customer.email.email) ? _c('span', [_vm._v("Invalid")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.email),
      expression: "reservation.customer.email"
    }],
    staticClass: "full mb-2",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.reservation.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Hotel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.accomodation),
      expression: "reservation.customer.accomodation"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.accomodation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "accomodation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Room")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.customer.room),
      expression: "reservation.customer.room"
    }],
    staticClass: "full",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.customer.room)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.customer, "room", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-center mt-3"
  }, [_c('checkbox', {
    staticClass: "mr-2",
    model: {
      value: (_vm.reservation.customer.sendEmailCopy),
      callback: function($$v) {
        _vm.$set(_vm.reservation.customer, "sendEmailCopy", $$v)
      },
      expression: "reservation.customer.sendEmailCopy"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Send a confirmation email to the customer")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 pb-3 flex-column"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [(_vm.reservation.event.bookingQuestionIsActive && _vm.reservation.event.bookingQuestion) ? _c('div', {
    staticClass: "col-sm-12 d-flex flex-column mb-3"
  }, [_c('label', [_vm._v("\n                    " + _vm._s(_vm.reservation.event.bookingQuestion) + "  "), (_vm.reservation.event.bookingQuestionIsMandatory) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.bookingAnswer),
      expression: "reservation.bookingAnswer"
    }],
    staticClass: "full p-2",
    class: {
      'border-color-6': _vm.$v.reservation.bookingAnswer.$invalid && _vm.reservation.event.bookingQuestionIsMandatory
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.bookingAnswer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "bookingAnswer", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.canSeeInternalNote) ? _c('div', {
    staticClass: "col-sm-12 d-flex flex-column mb-3"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.internalNote),
      expression: "reservation.internalNote"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "disabled": !_vm.canEditInternalNote,
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.internalNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "internalNote", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex flex-column"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.note),
      expression: "reservation.note"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "note", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Name "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Country "), _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Internal notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(internal use only)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                    Notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(agents can see these)")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b55782b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55782b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/CustomerDetails.vue
// module id = 2893
// module chunks = 0